import { inject } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { ROUTES } from '../../shared/constants';

/**
 * Guard that prevents unauthenticated users from accessing protected routes.
 * Redirects to the login page.
 */
export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const auth = inject(Auth);

  return authState(auth).pipe(
    take(1),
    map(user => {
      if (user) {
        return true;
      } else {
        return router.createUrlTree([ROUTES.AUTH.LOGIN]);
      }
    })
  );
};
